/* eslint-disable max-lines */

const moment = require('moment-timezone');
const React = require('react');
const {
  insurancePatientRelation,
  genders,
  defaultSettings,
  marital_status,
  employmentType,
  yesAndNoOptions,
  frequencyCode,
  tax_id_types
} = require('../constants/constants');
const customFormInitialStates = require('../../components/shared/Forms/Custom/CustomFormInitialStates');
const { badPwds } = require('./10kbadPwds');
const { set, get, isEqual: lodashIsEqual, groupBy } = require('lodash');
const showdown = require('showdown');
const cs = require('classnames');
const { twMerge } = require('tailwind-merge');

exports.cn = (...classes) => {
  return twMerge(cs(classes));
};

exports.Capitalize = (s) => {
  if (s) {
    if (s.length > 0) {
      const sa = s.split(/ /g);
      let r = '';
      sa.forEach((e, j) => {
        r += e[0]?.toUpperCase();
        for (let i = 1; i < e.length; i++) {
          r += e[i].toLowerCase();
        }
        if (j < sa.length - 1) {
          r += ' ';
        }
      });
      return r;
    } else {
      return s;
    }
  } else {
    return s;
  }
};

exports.optionify = (arr = [], label = 'name', value = 'id', meta) => {
  if (this.ia(arr)) {
    if (['string', 'number'].includes(typeof arr[0])) {
      return arr.map((v) => {
        return { label: v, value: v };
      });
    } else {
      const is_label_string = typeof label === 'string';
      const is_value_string = typeof value === 'string';
      const has_meta = meta !== undefined;
      let l = '';
      let v = '';
      return arr.map((e) => {
        if (is_label_string) {
          l = e[label];
        } else {
          l = label(e);
        }
        if (is_value_string) {
          v = e[value];
        } else {
          v = value(e);
        }
        if (has_meta) {
          return { label: l, value: v, meta: meta(e) };
        } else {
          return { label: l, value: v };
        }
      });
    }
  }
  if (typeof arr === 'object') {
    const keys = Object.keys(arr);
    const r = [];
    for (let i = 0; i < keys.length; i++) {
      r.push({ label: arr[keys[i]], value: keys[i] });
    }
    return r;
  }
  return [];
};

exports.Truncate = (s, len) => {
  if (s) {
    return s.length > len ? s.substring(0, len) + '...' : s;
  } else {
    return s;
  }
};

exports.formatPhoneNumber = (phoneNumberString = '') => {
  if (!phoneNumberString) return phoneNumberString;

  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumberString;
};

exports.formatNumberToOnlyNumbers = (value) => {
  // this function is different since it doesnt allow anything other then numbers
  // Keep only digits
  const numericValue = value?.replace(/\D/g, '');

  if (!numericValue || numericValue.length < 10) {
    return '';
  }

  // Remove leading '1' if it's a US number and the number is 11 digits
  if (numericValue.length === 11 && numericValue.startsWith('1')) {
    return numericValue.slice(1);
  }

  // Return first 10 digits
  return numericValue.slice(0, 10);
};

exports.randomString = (length = 0) => {
  if (length > 0) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  } else {
    return '';
  }
};

exports.verifyEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

exports.verifyPassword = (pass) => {
  const r = { strength: 'weak', messages: [], password_ok: true };
  // list of banned characters which cannot be present in the password
  const banned_characters = ['"', "'"];
  // presence of illegal characters in the password
  let illegal_char = false;
  // number of upper case letters in the password
  let upperCount = 0;
  // number of lower case letters in the password
  let lowerCount = 0;
  // number of special characters in the password
  let specialCount = 0;
  // strength count
  let password_strength = 0;
  // check the password
  for (let i = 0; i < pass.length; i++) {
    for (let j = 0; j < banned_characters.length; j++) {
      if (pass[i] === banned_characters[j] && !illegal_char) {
        r.password_ok = false;
        illegal_char = true;
        r.messages.push({
          type: 'weak',
          message: `Contains illegal characters (Password cannot contain ', ")`
        });
      }
    }

    if (pass.charCodeAt(i) > 64 && pass.charCodeAt(i) < 91) {
      upperCount++;
    } else if (pass.charCodeAt(i) > 96 && pass.charCodeAt(i) < 123) {
      lowerCount++;
    } else {
      specialCount++;
    }
  }

  // check if the password is a common one from the most commonly used passwords
  if (pass.length > 3 && badPwds.includes(String(pass).toLowerCase())) {
    // the password is one of the common phrases
    r.messages.push({
      type: 'weak',
      message: `Do not use common phrases or passwords`
    });
    r.password_ok = false;
  }

  if (upperCount === 0) {
    r.messages.push({ type: 'weak', message: 'No upper case characters present' });
    r.password_ok = false;
  } else if (upperCount === 1) {
    r.messages.push({ type: 'medium', message: 'Contains one upper case characters' });
    r.password_ok = r.password_ok && true;
    password_strength += 1;
  } else if (upperCount > 1) {
    r.messages.push({ type: 'strong', message: 'Contains multiple upper case characters' });
    r.password_ok = r.password_ok && true;
    password_strength += upperCount / 2;
  }

  if (lowerCount === 0) {
    r.messages.push({ type: 'weak', message: 'No upper case characters present' });
    r.password_ok = false;
  } else if (lowerCount === 1) {
    r.messages.push({ type: 'medium', message: 'Only one lower case character present' });
    r.password_ok = r.password_ok && true;
    password_strength += 1;
  } else if (lowerCount > 1) {
    r.messages.push({ type: 'strong', message: 'Multiple lower case characters present' });
    r.password_ok = r.password_ok && true;
    password_strength += lowerCount / 4;
  }

  if (specialCount === 0) {
    r.messages.push({ type: 'weak', message: 'No special characters present' });
    r.password_ok = false;
  } else if (specialCount === 1) {
    r.messages.push({ type: 'medium', message: 'Only one special character present' });
    r.password_ok = r.password_ok && true;
    password_strength += 1;
  } else if (specialCount > 1) {
    r.messages.push({ type: 'strong', message: 'Multiple special characters present' });
    r.password_ok = r.password_ok && true;
    password_strength += specialCount / 2;
  }

  if (pass.length < 6) {
    r.messages.push({ type: 'weak', message: 'Must be longer than 6 characters' });
    r.password_ok = false;
  } else if (pass.length >= 6 && pass.length < 12) {
    r.messages.push({ type: 'medium', message: 'Password fulfills minimum length' });
    r.password_ok = r.password_ok && true;
    password_strength += 1;
  } else if (pass.length >= 12) {
    r.messages.push({ type: 'strong', message: 'Password is of a good length' });
    r.password_ok = r.password_ok && true;
    password_strength += pass.length / 4;
  }

  if (password_strength >= 0 && password_strength < 4) {
    r.strength = 'weak';
  } else if (password_strength >= 4 && password_strength < 10) {
    r.strength = 'medium';
  } else if (password_strength >= 10) {
    r.strength = 'strong';
  }

  r.strengthValue = password_strength;

  return r;
};

exports.ia = (a, length = 0) => Array.isArray(a) && a?.length > length;

exports.iaRa = (a, length = 0) => (Array.isArray(a) && a.length > length ? a : []);

exports.search = (array, key, prop) => {
  prop = typeof prop === 'undefined' ? 'value' : prop;

  for (var i = 0; i < array.length; i++) {
    if (array[i][prop] === Number(key)) {
      return array[i]?.abbreviation || array[i]?.label;
    }
  }
};

exports.mString = (inN, cents = true) => {
  let n = 0;

  if (!isNaN(parseInt(inN))) {
    n = inN;
  }

  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(Math.abs(n / (cents ? 100 : 1)));

  if (n < 0) {
    return `-${formattedNumber}`;
  }

  return formattedNumber;
};

exports.formatLargeNumber = (n) => {
  return new Intl.NumberFormat('en-US').format(n);
};

exports.random = (min, max) => parseInt(Math.floor(Math.random() * (max - min + 1)) + min);

exports.pm = (permissions, requiredPermissions, logicType = 'and') => {
  try {
    if (exports.ia(requiredPermissions)) {
      // Iterate over required permissions based on the logic type
      for (let i = 0; i < requiredPermissions.length; i++) {
        const hasPermission = get(permissions, requiredPermissions[i]);

        if (logicType === 'or' && hasPermission) {
          return true; // Return true if one permission is found and logicType is 'or'
        }

        if (logicType === 'and' && !hasPermission) {
          return false; // Return false if any permission is missing and logicType is 'and'
        }
      }
      // If logicType is 'and', return true if all permissions are present
      return logicType === 'and';
    } else {
      return get(permissions, requiredPermissions);
    }
  } catch (error) {
    console.error('pmError', error);
    return false;
  }
};

exports.centsToDollar = (amount) => {
  return amount / 100;
};

exports.mergeStrings = (string_one, string_two) => {
  return `${string_one} ${string_two}`;
};

exports.keyChanges = (base, object) => {
  // courtesy of https://gist.github.com/Yimiprod/7ee176597fef230d1451
  const changes = {};

  function walk(base, object, path = '') {
    for (const [key, value] of Object.entries(object)) {
      try {
        const currentPath = Array.isArray(object)
          ? path + `[${key}]`
          : path === ''
            ? key
            : `${path}.${key}`;
        if (base[key] === undefined) {
          set(changes, currentPath, value);
        } else if (value !== base?.[key]) {
          if (typeof value === 'object') {
            walk(base?.[key] || {}, value, currentPath);
          } else {
            set(changes, currentPath, value);
          }
        }
      } catch (e) {
        console.log('error', key, value, e);
      }
    }
  }

  walk(base, object);

  return changes;
};

exports.io = (o, length = 0) => Object.keys(o || {})?.length > length;

exports.formatDateAndTime = (dateAndTime, timezone, onlyNumbers = true, otherFormat = '') => {
  const format = onlyNumbers ? 'MM/DD/YYYY h:mm A' : 'MMM D, YYYY h:mm A';
  if (!timezone) return moment(dateAndTime).format(format);

  return moment.tz(dateAndTime, timezone ?? undefined).format(otherFormat || format);
};
exports.formatDateAndTimeSeconds = (dateAndTime, timezone, onlyNumbers, otherFormat = '') => {
  const format = 'MM/DD/YYYY hh:mm:ss A';
  if (!timezone) return moment(dateAndTime).format(format);
  return moment.tz(dateAndTime, timezone ?? undefined).format(otherFormat || format);
};

exports.formatDateAndTimeZ = (dateAndTime, timezone) => {
  if (!timezone) return moment(dateAndTime).format('MM/DD/YYYY h:mm A z');
  return moment.tz(dateAndTime, timezone ?? undefined).format('MM/DD/YYYY h:mm A z');
};

exports.formatTimeZ = (dateAndTime, timezone) => {
  if (!timezone) return moment(dateAndTime).format('hh:mm A');
  return moment.tz(dateAndTime, timezone ?? undefined).format('hh:mm A');
};

exports.formatDate = (date, timezone, onlyNumbers = true, otherFormat = '') => {
  const format = onlyNumbers ? 'MM/DD/YYYY' : 'MMM D, YYYY';
  if (!timezone) return moment(date).format(otherFormat || format);

  return moment.tz(date, timezone ?? undefined).format(otherFormat || format);
};

exports.formatTime = (date, timezone, format = 'h:mm A') => {
  if (!timezone) return moment(date).format(format);
  return moment.tz(date, timezone ?? undefined).format(format);
};

exports.formatDateNative = (date) => {
  // MM/DD/YYYY
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${month}/${day}/${year}`;
};

exports.splitName = (fullName) => {
  const nameParts = fullName?.split(' ');
  let firstName = '';
  let middleName = '';
  let lastName = '';
  let startIndex, endIndex, subArr, mName;

  switch (nameParts.length) {
    case 1:
      firstName = nameParts[0];
      break;
    case 2:
      firstName = nameParts[0];
      lastName = nameParts[1];
      break;
    case 3:
      firstName = nameParts[0];
      middleName = nameParts[1];
      lastName = nameParts[2];
      break;
    default:
      startIndex = 1;
      endIndex = nameParts.length - 2;
      subArr = nameParts.slice(startIndex, endIndex);
      mName = subArr.join(' ');
      firstName = nameParts[0];
      middleName = mName;
      lastName = nameParts[nameParts.length - 1];
      break;
  }

  return {
    firstName,
    middleName,
    lastName
  };
};

exports.isEmpty = (value) => {
  return value == null || (typeof value === 'string' && value.trim().length === 0);
};

exports.replaceNullValues = (obj) => {
  const cleanedObject = { ...obj };
  for (const key in cleanedObject) {
    if (cleanedObject[key] === null) {
      cleanedObject[key] = '';
    }
  }
  return cleanedObject;
};

exports.findRelationName = (relationType) => {
  const relation = insurancePatientRelation?.find((relation) => {
    if (relation?.value == relationType) {
      return relation;
    }
  });

  return relation && relation?.label;
};

exports.findStateName = ({ states, stateId }) => {
  if (!this.ia(states)) return;

  const state = states?.find((state) => {
    if (state.value == stateId) {
      return state;
    }
  });

  return state && state?.label;
};

exports.findGenderName = (genderValue) => {
  if (!this.ia(genders)) return;

  const gender = genders?.find((gender) => {
    if (gender.value === genderValue) return gender;
  });

  return gender;
};

exports.mapGenderValue = (value) => {
  if (!value) return null;

  if (value === 'other') return 'U';
  if (value === 'female' || value === 'male') return this.Capitalize(value)[0];

  return 'U';
};

exports.initials = ({ fullName = '', firstName = '', lastName = '' }) => {
  if (fullName) {
    const separated = fullName.split(' ');
    firstName = separated[0];
    lastName = separated[separated.length - 1];
  }
  return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;
};

exports.formatDateRelativeToToday = (date, timezone) => {
  const now = moment();
  const dateToFormat = moment.tz(date, timezone ?? undefined);
  const diffInDays = now.diff(dateToFormat, 'days');

  let formattedDate;
  if (diffInDays === 0) {
    formattedDate = 'TODAY';
  } else if (diffInDays === 1) {
    formattedDate = 'YESTERDAY';
  } else {
    formattedDate = `${diffInDays} days ago`;
  }

  return formattedDate;
};

exports.formatTimeRelativeToToday = (date, timezone) => {
  const now = moment();
  const dateToFormat = moment.tz(date, timezone ?? undefined);

  const diffInMinutes = now.diff(dateToFormat, 'minutes');
  if (diffInMinutes < 60) {
    return diffInMinutes === 0 ? 'now' : `${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''} ago`;
  }

  const diffInHours = now.diff(dateToFormat, 'hours');
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  }

  const diffInDays = now.diff(dateToFormat, 'days');
  return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
};

exports.cmToFt = (cm) => {
  if (cm) {
    const feet = Math.floor(cm / 30.48);
    const inches = Math.round((cm / 2.54) % 12);

    return feet + "'" + inches;
  } else {
    return '';
  }
};

exports.orderById = (arrayToSort, arrayBasedOn) => {
  if (arrayToSort && arrayToSort.length > 0) {
    return arrayToSort.sort(
      (a, b) =>
        arrayBasedOn.find((fp) => fp.id === a.id).order -
        arrayBasedOn.find((fp) => fp.id === b.id).order
    );
  }
};

exports.removeUnderscores = (text) => {
  if (typeof text !== 'string') return text;
  return text.replace(/_/g, ' ');
};

exports.checkValueExists = (value) => {
  if (Array.isArray(value)) return this.ia(value);

  if (typeof value === 'string') return !this.isEmpty(value);

  return false;
};

exports.isEqual = (value1, value2) => {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return (
      value1.length === value2.length &&
      value1.every((elem, index) => this.isEqual(elem, value2[index]))
    );
  }
  if (typeof value1 === 'object' && typeof value2 === 'object') {
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    return (
      keys1.length === keys2.length && keys1.every((key) => this.isEqual(value1[key], value2[key]))
    );
  }
  return String(value1) === String(value2);
};

exports.compareObjects = (obj1, obj2) => {
  const props1 = Object.keys(obj1);
  const props2 = Object.keys(obj2);

  if (props1.length !== props2.length) return false;

  for (const prop of props1) {
    if (!props2.includes(prop)) return false;

    const value1 = obj1[prop];
    const value2 = obj2[prop];

    if (!this.isEqual(value1, value2)) return false;
  }

  return true;
};

exports.getDirtyValues = (object1 = {}, object2 = {}) => {
  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      (typeof value === 'object' && !(value instanceof Date) && Object.keys(value).length === 0) ||
      (Array.isArray(value) && value.length === 0)
    );
  };

  const isEqual = (obj1, obj2) => {
    if (isEmptyValue(obj1) && isEmptyValue(obj2)) {
      return true; // Treat all empty-like values as equal
    }
    return lodashIsEqual(obj1, obj2);
  };

  const dirtyValues = {};
  Object.keys(object1).forEach((key) => {
    if (!isEqual(object1[key], object2[key])) {
      dirtyValues[key] = object1[key];
    }
  });

  return dirtyValues;
};

exports.isSameArray = (arr1, arr2) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;

  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (!this.compareObjects(arr1[i], arr2[i])) return false;
  }

  return true;
};

exports.responseUpdated = ({ currentForm, submitResponse }) => {
  if (currentForm?.response) {
    const parsedResponse = JSON.parse(currentForm.response.json.fields);

    return !this.isSameArray(submitResponse, parsedResponse);
  }

  if (!currentForm?.json?.fields) {
    return submitResponse.some((response) => this.checkValueExists(response?.value));
  }

  const fields =
    typeof currentForm?.json?.fields === 'string'
      ? JSON.parse(currentForm?.json?.fields)
      : currentForm?.json?.fields;
  const initialFormState = fields.find((field) => field.key)?.key;

  if (!initialFormState) {
    if (typeof currentForm?.json?.fields === 'string' && JSON.parse(currentForm?.json?.fields)) {
      let parsedCurrentForm = JSON.parse(currentForm?.json?.fields);

      parsedCurrentForm = parsedCurrentForm.map((row) => {
        const rowHasDatePickerProp = row.name.includes('date_picker');
        const rowWithNoValueProp = !Object.prototype.hasOwnProperty.call(row, 'value');

        if (rowHasDatePickerProp && rowWithNoValueProp) {
          return { ...row, value: undefined };
        }

        return row;
      });

      const checkIfObjectsSame = this.compareObjects(parsedCurrentForm, submitResponse);

      return !checkIfObjectsSame;
    } else {
      return submitResponse.some((response) => {
        if (response?.name?.includes('dropdown') && response?.value === '_') return false;

        return this.checkValueExists(response?.value);
      });
    }
  }

  return currentForm.json.fields
    ?.filter((field) => !field.static)
    ?.some((field, index) => {
      const currentResponse = submitResponse[index]?.value;

      if (field?.key) {
        const fieldKey = field.key;

        let initialObj = customFormInitialStates[fieldKey];

        if (fieldKey === 'ReviewSystems') {
          initialObj = {
            practitioner: customFormInitialStates[fieldKey],
            patient: customFormInitialStates[fieldKey]
          };
        }

        return submitResponse[index]?.value !== JSON.stringify(initialObj);
      }

      return this.checkValueExists(currentResponse);
    });
};

exports.showCardExpiration = (cardExpiration) => {
  if (!cardExpiration) return 'N/A';

  const firstPart = cardExpiration.slice(0, 2);
  const secondPart = cardExpiration.slice(2);

  return `${firstPart}/${secondPart}`;
};

exports.getFullAddress = ({ address, states }) => {
  if (!this.io(address) || !this.ia(states)) return;

  let stateName = '';

  const {
    address_ln_1 = '',
    address_ln_2 = '',
    city = '',
    state = '',
    country = '',
    zip = ''
  } = address || {};

  if (typeof state === 'number') stateName = this.search(states, state, 'id');

  const merge = [address_ln_1, address_ln_2, city, stateName, country, zip]
    .filter(Boolean)
    .join(', ')
    .trim();

  return merge;
};

exports.calculateBMI = ({ weight, height }) => {
  if (!weight || !height) return 0;

  const w = Number(weight) / 2.205;
  const h = (Number(height) / 100) ** 2;

  return (w / h).toFixed(1);
};

exports.deleteKeys = ({ object, keys }) => {
  keys?.forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(object, key)) delete object[key];
  });

  return object;
};

exports.updateAppointmentFilters = ({
  setUserState = false,
  data = {},
  clearData = false
} = {}) => {
  setUserState &&
    setUserState((prevState) => ({
      ...prevState,
      display_settings: {
        ...prevState.display_settings,
        appointmentFilters: clearData
          ? defaultSettings.appointmentFilters
          : {
              ...prevState.display_settings.appointmentFilters,
              ...data
            }
      }
    }));
};

// use: filePath(import.meta.url)
exports.filePath = (metaUrl) => {
  const url = new URL(metaUrl);

  const path = url?.pathname;
  // const filename = path.split('/').pop();

  return path.split('/myriad-frontend')[1];
  // return { path, filename };
};

const keysToKeep = ['id', 'name', 'email', 'error', 'code'];

exports.sanitizeResponse = (obj) => {
  if (!obj) return null;

  const k = Object.keys(obj);
  const r = {};
  for (let i = 0; i < k.length; i++) {
    if (typeof obj[k[i]] === 'object') {
      if (Array.isArray(obj[k[i]])) {
        r[k[i]] = [];
        let keyAllowed = false;
        for (const key in keysToKeep) {
          if (k[i].toLowerCase().includes(keysToKeep[key])) {
            keyAllowed = true;
          }
        }
        for (let j = 0; j < obj[k[i]].length; j++) {
          if (typeof obj[k[i]][j] === 'object') {
            const newKI = exports.sanitizeResponse(obj[k[i]][j]);
            if (newKI) r[k[i]][j] = newKI;
          } else if (
            (typeof obj[k[i]][j] === 'string' || typeof obj[k[i]][j] === 'number') &&
            keyAllowed
          ) {
            r[k[i]][j] = obj[k[i]][j];
          }
        }
      } else {
        const newKI = exports.sanitizeResponse(obj[k[i]]);
        if (newKI) {
          r[k[i]] = newKI;
        }
      }
    } else {
      for (const key in keysToKeep) {
        if (k[i].toLowerCase().includes(keysToKeep[key])) r[k[i]] = obj[k[i]];
      }
    }
  }
  return r;
};

exports.getOrdinalSuffix = ({ number = null }) => {
  if (!number) return null;

  let suffix = null;
  const lastDigit = number % 10;
  switch (lastDigit) {
    case 1:
      suffix = 'st';
      break;
    case 2:
      suffix = 'nd';
      break;
    case 3:
      suffix = 'rd';
      break;
    default:
      suffix = 'th';
      break;
  }

  return `${number}${suffix}`;
};

exports.lbsToKg = (lbs) => parseFloat(lbs * 0.45359237).toFixed(2);
exports.cmToInch = (cm) => parseFloat((cm / 2.54).toFixed(2));
exports.inchToCm = (inch) => parseFloat(inch * 2.54).toFixed(2);

exports.separatePoundsAndOunces = (weightInPounds) => {
  const pounds = Math.floor(weightInPounds);
  const ounces = (weightInPounds - pounds) * 16; // 1 pound = 16 ounces
  return { pounds: parseInt(pounds) || '', ounces: parseInt(ounces) || '' };
};

exports.separateFeetAndInches = (heightInInches) => {
  const feet = Math.floor(heightInInches / 12);
  const inches = heightInInches % 12;
  return { feet: parseInt(feet) || '', inches: parseInt(inches) || '' };
};

exports.spaceToUppercase = (title) => {
  if (title) {
    return title
      .split(' ')
      .map((word, index) =>
        index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join('');
  }
  return '';
};

exports.spaceToKebabCase = (title) => {
  if (title) {
    const cleanedTitle = title?.toLowerCase?.()?.replace?.(/[^\w\s]/g, '');
    const kebabCaseTitle = cleanedTitle?.replace?.(/\s+/g, ' ')?.split?.(' ')?.join?.('-');
    return kebabCaseTitle;
  }
  return '';
};

exports.camelToKebabCase = (title) => {
  if (typeof title === 'string') {
    const kebabCaseTitle = title.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    return kebabCaseTitle;
  }
  return '';
};

exports.camelToKebabKeys = (obj) => {
  const newObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const kebabKey = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      newObj[kebabKey] = obj[key];
    }
  }
  return newObj;
};

exports.kebabToReadable = (kebabCaseStr) =>
  kebabCaseStr
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

exports.camelCaseToReadableFormat = (text) => {
  const words = text?.replace(/([a-z])([A-Z])/g, '$1 $2')?.split(/(?=[A-Z])/);
  const readableText = this.iaRa(words)
    ?.map((word) => word.toLowerCase())
    .join(' ');
  const capitalizeText = readableText?.charAt(0).toUpperCase() + readableText?.slice(1);
  return capitalizeText;
};

exports.camelToSpaceCase = (title) => {
  if (typeof title === 'string') {
    const spaceCaseTitle = title.replace(/([a-z])([A-Z])/g, '$1 $2');
    return spaceCaseTitle.charAt(0).toUpperCase() + spaceCaseTitle.slice(1);
  }
  return '';
};

exports.snakeToTitleCase = (s) =>
  s?.replace(/_/g, ' ')?.replace(/\b\w/g, (match) => match.toUpperCase());

exports.snakeToKebabCase = (str) => {
  if (typeof str !== 'string') return str;
  return str.replace(/_/g, '-');
};

exports.readableToSnakeCase = (s) =>
  s
    .split(' ')
    .map((word) => word.toLowerCase())
    .join('_')
    .replace(/[^a-z0-9_]/g, '');

exports.sortObjectByProperty = (obj, prop) => {
  const entries = Object.entries(obj);
  entries.sort(([, a], [, b]) => a[prop] - b[prop]);
  const sortedObject = {};
  entries.forEach(([key, value]) => {
    sortedObject[key] = value;
  });
  return sortedObject;
};

exports.groupAndSort = (array = [], key = '') => {
  const groupedOptions = groupBy(array, (option) => option[key] || 'others');
  return Object.entries(groupedOptions).sort(([groupNameA], [groupNameB]) => {
    if (groupNameA === 'others') return 1;
    if (groupNameB === 'others') return -1;
    return 0; // Keep original order
  });
};

exports.formatCurrencyValue = (value) => {
  return value ? (value / 100).toFixed(2) : '0.00';
};

exports.reShapePractitioners = (practitioners = []) => {
  return practitioners?.map(({ id, f_name, l_name, profile_photo, virtual_link }) => ({
    value: id,
    label: `${f_name} ${l_name}`,
    virtual_link,
    ...(profile_photo && {
      image: this.filestackPath(JSON.parse(profile_photo || `{}`)?.jpg)
    })
  }));
};

exports.reShapePatients = (patients = []) => {
  return patients?.map(({ id, f_name, l_name }) => ({
    value: id,
    label: `${f_name} ${l_name}`
  }));
};

exports.reShapeProcedures = (procedures = []) => {
  return procedures?.map((service) => ({
    ...service,
    value: service?.id,
    label: service?.name,
    timeLength: service?.time_length
  }));
};

exports.reShapeProducts = (products = []) => {
  return products?.map((p) => ({
    ...p,
    total_amount_cents: p?.amount_cents,
    sales_count: 1,
    ...(p?.image && {
      image: this.filestackPath(JSON.parse(p?.image || `{}`)?.jpg)
    })
  }));
};

exports.groupByDate = (data = [], field = 'created_at', format = 'MMM D, YYYY') => {
  return data.reduce((grouped, item) => {
    const date = moment(item[field]).format(format);

    if (!grouped[date]) grouped[date] = [];

    grouped[date].push(item);

    return grouped;
  }, {});
};

exports.sumBy = (items = [], key) => {
  // support nested key
  if (key.includes('.')) {
    const keys = key.split('.');
    const nestedKey = keys.pop();

    return (
      items?.reduce?.((total, item) => {
        const nestedValue = keys.reduce((obj, parentKey) => obj?.[parentKey], item);
        return total + Number(nestedValue?.[nestedKey] || 0) || 0;
      }, 0) || 0
    );
  }

  return items?.reduce?.((total, item) => total + Number(item[key] || 0), 0) || 0;
};

exports.arrayToObject = (items = [], key, value) => {
  if (!key || !value) return items || [];

  return (
    items.reduce((acc, item) => {
      acc[item[key]] = item[value];
      return acc;
    }, {}) || {}
  );
};

exports.convertJSONToCSV = (jsonData) => {
  const csvRows = [];
  const isArray = Array.isArray(jsonData);

  if (isArray && !jsonData.length > 0) {
    return;
  }

  const headers = Object.keys(isArray ? jsonData[0] : jsonData);
  csvRows.push(headers.join(','));

  if (isArray) {
    for (const row of jsonData) {
      const values = headers.map((header) => {
        const escaped = ('' + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
  } else {
    const values = headers.map((header) => {
      const escaped = ('' + jsonData[header]).replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

exports.downloadCSV = (csvContent, filename = 'data.csv') => {
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

exports.claimCSV = (claim) => {
  const matchedRelation = insurancePatientRelation.find((item) => item.label === claim?.pat_rel);
  const matchedMaritalStatus = marital_status.find((item) => item.label === claim?.pat_marital);
  const matchedEmplStatus = employmentType.find((item) => item.label === claim?.pat_employment);
  const matchedEmplRelStatus = yesAndNoOptions.find(
    (item) => item.label === claim?.employment_related
  );
  const matchedAccidentStatus = yesAndNoOptions.find((item) => item.label === claim?.auto_accident);
  const matchedOtherAccidentStatus = yesAndNoOptions.find(
    (item) => item.label === claim?.other_accident
  );
  const matchedOtherPtRelStatus = insurancePatientRelation.find(
    (item) => item.label === claim?.other_pat_rel
  );
  const matchedFrequencyStatus = frequencyCode.find((item) => item.label === claim?.frequency_code);
  const matchedTaxTypesStatus = tax_id_types.find((item) => item.label === claim?.bill_taxid_type);
  const matchedASStatus = yesAndNoOptions.find((item) => item.label === claim?.accept_assign);
  if (claim.cond_date) claim['cond_date'] = moment(claim.cond_date).format('MM/DD/YYYY');
  claim?.procedures?.map((procedure, index) => {
    claim[`charge_${index + 1}`] = parseFloat(procedure.charge * parseInt(procedure.units)).toFixed(
      2
    );
    claim[`diag_ref_${index + 1}`] = procedure.diagnosis;
    claim[`from_date_${index + 1}`] = procedure.from_date
      ? moment(procedure.from_date).format('MM/DD/YYYY')
      : null;
    if (this.ia(procedure?.modifiers)) {
      procedure.modifiers.map((modifier, i) => {
        claim[`mod${i + 1}_${index + 1}`] = modifier;
      });
    } else if (typeof procedure?.modifier === 'string') {
      procedure?.modifiers?.split(',').map((modifier, i) => {
        claim[`mod${i + 1}_${index + 1}`] = modifier;
      });
    }
    claim[`narrative_${index + 1}`] = procedure.narrative;
    claim[`proc_code_${index + 1}`] = procedure.code;
    claim[`thru_date_${index + 1}`] = procedure.thru_date
      ? moment(procedure.thru_date).format('MM/DD/YYYY')
      : null;
    claim[`units_${index + 1}`] = procedure.units;
    claim[`place_of_service_${index + 1}`] = procedure.place_of_service;
    claim['remote_claimid'] = claim.id;
    claim['pat_dob'] = moment(claim.pat_dob).format('YYYY-MM-DD');
    claim['ins_dob'] = claim.ins_dob && moment(claim.ins_dob).format('YYYY-MM-DD');
    claim['pat_sex'] = this.mapGenderValue(claim.pat_sex);
    claim['ins_sex'] = this.mapGenderValue(claim.ins_sex);
    claim['other_ins_sex'] = this.mapGenderValue(claim.other_ins_sex);
    claim['pat_rel'] = matchedRelation?.value || claim?.pat_rel || '';
    claim['pat_marital'] = matchedMaritalStatus?.value || claim?.pat_marital || null;
    claim['pat_employment'] = matchedEmplStatus?.value || claim?.pat_employment || null;
    claim['employment_related'] = matchedEmplRelStatus?.value || claim?.employment_related || null;
    claim['auto_accident'] = matchedAccidentStatus?.value || claim?.auto_accident || null;
    claim['other_accident'] = matchedOtherAccidentStatus?.value || claim?.other_accident || null;
    claim['other_pat_rel'] = matchedOtherPtRelStatus?.value || claim?.other_pat_rel || null;
    claim['frequency_code'] = matchedFrequencyStatus?.value || claim?.frequency_code || null;
    claim['bill_taxid_type'] = matchedTaxTypesStatus?.value || claim?.bill_taxid_type || null;
    claim['accept_assign'] = matchedASStatus?.value || claim?.accept_assign || null;
  });

  this.deleteKeys({
    object: claim,
    keys: [
      'state',
      'errors',
      'superbill',
      'custom_id',
      'updated_at',
      'created_at',
      'procedures',
      'practice_id',
      'practitioner',
      'state_history',
      'insurance_payment'
    ]
  });

  claim = this.replaceNullValues(claim);

  const csv = this.convertJSONToCSV(claim);
  return csv;
};

function hexToRgb(hex) {
  // Remove the hash character (#) if it's present
  hex = hex?.replace(/^#/, '');

  // Parse the hexadecimal color into its RGB components
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}

function calculateLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);

  // Calculate the relative luminance using the formula
  const luminance = 0.2126 * (r / 255) + 0.7152 * (g / 255) + 0.0722 * (b / 255);

  return luminance;
}

exports.isColorLight = (hex) => {
  const luminance = calculateLuminance(hex);

  // You can adjust the threshold (0.5) to determine what you consider "light" or "dark"
  return luminance > 0.75;
};

exports.getKeysByType = (obj, type) => {
  const numberKeys = [];
  const nonNumberKeys = [];

  for (const key in obj) {
    if (key === 'B7' || (type === 'number' && !isNaN(Number(key)))) {
      numberKeys.push(key);
    } else if (type === 'letter' && isNaN(Number(key))) {
      nonNumberKeys.push(key);
    }
  }

  if (type === 'number') {
    return numberKeys;
  } else if (type === 'letter') {
    return nonNumberKeys;
  } else {
    return { numberKeys, nonNumberKeys };
  }
};

exports.getPatientDateRangeInDays = (patientCreatedDate) => {
  const startDate = moment.utc().startOf('day').diff(moment.utc().startOf('day'), 'days');
  const endDate = moment
    .utc()
    .endOf('day')
    .diff(moment.utc(patientCreatedDate).endOf('day'), 'days');

  return { startDate, endDate };
};

exports.getInitials = (fullName) => {
  const names = fullName?.split(' ');
  const initials = names
    ?.map((name, index) => {
      if (index === names.length - 1) {
        return name.charAt(0).toUpperCase();
      }
      return name.charAt(0).toUpperCase() + '.';
    })
    .join('');

  return initials;
};

exports.calcDiscount = (discount, total_amount) => {
  if (!discount) return 0;

  let discountAmount;

  const { value, type } = discount || {};

  if (type === 'percent') {
    discountAmount = (total_amount * value) / 100 / 100;
  } else if (type === 'amount') {
    discountAmount = value;
  } else {
    discountAmount = 0;
  }

  return discountAmount;
};

exports.calculateAge = ({ dateOfBirth = undefined }) => {
  return moment.utc().diff(dateOfBirth, 'years');
};

exports.objMap = (obj, func) => {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, func(k, v)]));
};

exports.findRelationValue = (relationLabel) => {
  const relation = insurancePatientRelation?.find((relation) => {
    if (relation?.label == relationLabel) {
      return relation;
    }
  });

  return relation && relation?.value;
};
exports.mapValues = (values) => {
  if (!values) return {};
  return this.objMap(values, (_, f) =>
    typeof f === 'object' && Object.keys(f).includes('values') ? f.values : f
  );
};

exports.removeBracketsInText = (text) => {
  if (this.isEmpty(text)) return '';

  return text?.replace(/\[|\]/g, '');
};

exports.hasObjectTrueValues = (obj) => {
  for (const key in obj) {
    if (obj[key] > 0) {
      return true;
    }
  }
  return false;
};

exports.isValidDate = (date) => {
  return moment(date).isValid() ? date : null;
};

exports.hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex?.substring(1, 3), 16);
  const g = parseInt(hex?.substring(3, 5), 16);
  const b = parseInt(hex?.substring(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha}%)`;
};

exports.hexToRGBObject = (hex) => {
  const r = parseInt(hex?.substring(1, 3), 16) / 255;
  const g = parseInt(hex?.substring(3, 5), 16) / 255;
  const b = parseInt(hex?.substring(5, 7), 16) / 255;
  return { r: r || 0, g: g || 0, b: b || 0 };
};

exports.removeSpecialChar = (e) => {
  if (!/[0-9a-zA-Z ]/.test(e.key)) {
    e.preventDefault();
  }
};

exports.allowValidNameChars = (e) => {
  const inputElement = e.target;

  const validNameRegex = /^[a-zA-Z0-9\u00C0-\u024F'-. ]$/;

  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
    'Escape',
    'Home',
    'End'
  ];

  if (!validNameRegex.test(e.key) && !allowedKeys.includes(e.key) && !(e.ctrlKey || e.metaKey)) {
    e.preventDefault();
    return;
  }

  if (e.key === ' ' && inputElement.selectionStart === 0) {
    e.preventDefault();
  }

  const currentValue = inputElement.value;
  const cursorPos = inputElement.selectionStart;
  const nextValue = currentValue.slice(0, cursorPos) + e.key + currentValue.slice(cursorPos);

  if (/[.'-]{2,}/.test(nextValue)) {
    e.preventDefault();
  }
};

exports.getHours = (minuteSpan = 5) => {
  const times = [];
  const totalIntervals = (24 * 60) / minuteSpan;
  for (let i = 0; i < totalIntervals; i++) {
    const totalMinutes = i * minuteSpan;
    let hour = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const period = hour < 12 ? 'AM' : 'PM';

    if (hour === 0) {
      hour = 12;
    } else if (hour > 12) {
      hour -= 12;
    }

    const time = hour + ':' + (minutes < 10 ? '0' + minutes : minutes) + ' ' + period;
    times.push(time);
  }
  return this.optionify(times);
};

exports.findAppointmentStatusLabel = (appointmentStatuses, value) => {
  const status = appointmentStatuses.find((status) => status?.value === value);
  return status ? status?.label : value;
};

exports.findAppointmentStatusColor = (appointmentStatuses, value) => {
  const status = appointmentStatuses.find((status) => status?.value === value);
  return status ? status?.color : value;
};

exports.stripHtmlTags = (content) => {
  if (!content) return;
  const temp = document.createElement('div');
  temp.innerHTML = content;
  return temp.textContent || temp.innerText || '';
};

exports.roundToNearestHalf = (num) => {
  return Math.round(num * 2) / 2;
};

exports.removeHtmlTags = (html, options = { preserveSpacing: true }) => {
  if (!html) return '';

  const { preserveSpacing } = options;

  let processed = html.replace(/<br\s*\/?>/gi, ' ');

  if (preserveSpacing) {
    processed = processed.replace(/<\/(p|div|h[1-6]|li|section|article|header|footer)>/gi, ' ');
    processed = processed.replace(/<(ul|ol)>/gi, ' ');
  }

  processed = processed.replace(/<[^>]*>/g, '');

  return processed.replace(/\s+/g, ' ').trim();
};

exports.copyOnClipboard = ({ text, onSuccess = () => {}, onError = () => {} }) => {
  navigator.clipboard
    .writeText(text)
    .then(() => onSuccess())
    .catch(() => onError());
};

exports.formatName = (lastName, firstName, middleName) => {
  let formattedName = `${lastName || ''}`;

  if (firstName) {
    formattedName += `${lastName ? ', ' : ''}${firstName}`;
  }

  if (middleName) {
    formattedName += `, ${middleName[0]}`;
  }

  return formattedName;
};

exports.singularize = (word) => {
  const endings = {
    ves: 'fe',
    ies: 'y',
    i: 'us',
    zes: 'ze',
    ses: 's',
    es: 'e',
    s: ''
  };
  return word.replace(new RegExp(`(${Object.keys(endings).join('|')})$`), (r) => endings[r]);
};

exports.numberFormatter = new Intl.NumberFormat('en-US');
exports.getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

exports.pluralize = (word, count, excludeWords = []) => {
  if (excludeWords.includes(word.toLowerCase())) return word;

  if (count === 1) return word;

  if (word.endsWith('y') && !/[aeiou]y$/.test(word)) {
    return word.slice(0, -1) + 'ies';
  }

  if (/(x|z|ch|sh)$/.test(word)) {
    return word + 'es';
  }

  if (/(s)$/.test(word)) {
    return word;
  }

  return word + 's';
};

exports.filestackPath = (image) =>
  `${process.env.REACT_APP_BASE_API_URL}/api/resources/images/${image}`;

exports.getPublicImagePath = (image, practiceId) =>
  `${process.env.REACT_APP_BASE_API_URL}/api/public/resources/images/${image}/${practiceId}`;

exports.deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every((key) => keys2.includes(key) && this.deepEqual(obj1[key], obj2[key]));
};

exports.isJSON = (value) => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

exports.safeParseJSON = (jsonString, fallback = null) => {
  try {
    if (!jsonString || typeof jsonString !== 'string') return fallback;
    return JSON.parse(jsonString);
  } catch (error) {
    return fallback;
  }
};

exports.highlightText = (text, highlights) => {
  if (!highlights.length) return text;
  const regex = new RegExp(`\\b(${highlights.join('|')})\\b`, 'g');
  const parts = text.split(regex).filter(Boolean);

  return parts.map((part, index) => {
    if (highlights.includes(part)) {
      return React.createElement('strong', { key: index }, part);
    }
    return React.createElement('span', { key: index }, part);
  });
};

exports.formatClaimStatus = ({ status, toUpper = false }) => {
  if (status === 'accepted') {
    return toUpper ? 'ACKNOWLEDGED' : 'acknowledged';
  }
  return toUpper ? status?.toUpperCase() : status;
};

exports.convertMarkdownToHTML = (markdown) => {
  const converter = new showdown.Converter();
  return converter.makeHtml(new String(markdown));
};

exports.getNumberFormatter = (options = {}) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    ...options
  });
};

exports.getCurrencySymbol = ({ locale = 'en-US', currency = 'USD' }) => {
  const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
  const parts = formatter.formatToParts(0);
  const symbol = parts.find((part) => part.type === 'currency')?.value;
  return symbol || currency;
};

exports.formatTimeShortRelativeToToday = (date, timezone) => {
  const now = moment();
  const dateToFormat = moment.tz(date, timezone ?? undefined);

  const diffInSeconds = now.diff(dateToFormat, 'seconds');
  if (diffInSeconds < 60) {
    return 'now';
  }

  const diffInMinutes = now.diff(dateToFormat, 'minutes');
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }

  const diffInHours = now.diff(dateToFormat, 'hours');
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  const diffInDays = now.diff(dateToFormat, 'days');
  if (diffInDays < 8) {
    return `${diffInDays}d ago`;
  }

  return this.formatDateAndTime(date, timezone);
};

exports.customEval = (obj, field) => {
  if (!field.includes('.')) {
    return obj?.[field];
  }

  return field.split('.').reduce((acc, key) => acc?.[key], obj);
};

exports.isPrimitiveValue = (value) => {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
};

exports.isArrayWithPrimitive = (value) => {
  if (!Array.isArray(value)) {
    return;
  }

  return value.every((item) => this.isPrimitiveValue(item));
};

exports.errorMessageGuard = (error) => {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    if (typeof error.message === 'string' && error.message.trim()) {
      return error.message;
    }
    if (typeof error.error === 'string' && error.error.trim()) {
      return error.error;
    }
  }

  return 'Unexpected Error has occurred!';
};

exports.inRn = (value, defaultNumber = 0) => {
  const next = Number(value);
  const safeNumber = Number.isFinite(next)
    ? Math.max(defaultNumber, Math.floor(next))
    : defaultNumber;

  return safeNumber;
};

exports.getChangedFields = (originalObj, newObj) => {
  const changes = {};

  for (const key in newObj) {
    if (!(key in originalObj) || !lodashIsEqual(originalObj[key], newObj[key])) {
      if (
        typeof newObj[key] === 'object' &&
        typeof originalObj[key] === 'object' &&
        !Array.isArray(newObj[key]) &&
        !Array.isArray(originalObj[key])
      ) {
        const nestedChanges = this.getChangedFields(originalObj[key], newObj[key]);
        if (Object.keys(nestedChanges).length > 0) {
          changes[key] = nestedChanges;
        }
      } else {
        changes[key] = newObj[key];
      }
    }
  }

  return changes;
};
